import { handleActions } from "redux-actions";
import { setCurrentPage, clearCurrentPage } from "../../../actions";

const defaultState = {
  page: null,
  name: null,
  params: null,
};

export default handleActions(
  {
    [setCurrentPage]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),

    [clearCurrentPage]: () => defaultState,
  },
  defaultState
);